import React, { FC } from "react";

import {
  ActionValue,
  basketTotalCountSelector,
  DataViewKey,
  dataViewPage,
  selectedElements,
  useBasketDownload,
} from "@keepeek/commons";
import { KButtonAction, withSuspense } from "@keepeek/refront-components";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import { KIcon } from "../../../../components/common/KIcon";

export type BasketDownloadActionProps = {
  basketId?: number;
};
const BasketDownloadAction: FC<BasketDownloadActionProps> = function ({ basketId }) {
  const totalCount = useRecoilValue(basketTotalCountSelector(basketId));

  const selectedElementIds = useRecoilValue(selectedElements(DataViewKey.BASKET));
  const page = useRecoilValue(dataViewPage(DataViewKey.BASKET));
  const download = useBasketDownload(DataViewKey.BASKET, selectedElementIds, page, basketId);
  const { t } = useTranslation();

  return (
    <KButtonAction
      key="basketDownloadButton"
      className="BasketActions-basketDownloadButton"
      onClick={download}
      aria-label={t("basket.action.download.label")}
      size="small"
      actionButtonName={ActionValue.DOWNLOAD}
      title={t("basket.action.download.label")}
      data-testid="basketDownloadButton"
      disabled={totalCount <= 0}
    >
      <KIcon fontSize="small" className={"fa-solid fa-cloud-arrow-down"} />
    </KButtonAction>
  );
};

const BasketDownloadActionLoading: FC = function () {
  const { t } = useTranslation();
  return (
    <KButtonAction
      size="small"
      key="basketDownloadButton"
      className="BasketActions-basketDownloadButton"
      aria-label={t("basket.action.download.label")}
      actionButtonName={ActionValue.DOWNLOAD}
      title={t("basket.action.download.label")}
      data-testid="basketDownloadButton"
      disabled
      onClick={() => {}}
    >
      <KIcon fontSize="small" className={"fa-solid fa-cloud-arrow-down"} />
    </KButtonAction>
  );
};

export default withSuspense(BasketDownloadAction, {
  LoadingComponent: BasketDownloadActionLoading,
});
